import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { IconButtonComponent } from "@components/icon-button/icon-button.component";
import { InputNumberComponent } from "@components/input-number/input-number.component";
import { SelectorComponent } from "@components/selector/selector.component";
import _ from "lodash";
import { Atgard } from "~app/features/virkeskop/models/atgard-models";
import { TradslagDTO } from "~app/features/virkeskop/models/mbf-models";
import { AtgardSkogsvardTradslag } from "~app/features/virkeskop/models/skogsvard/skogsvard-models";
import { SkogsvardForyngringService } from "~app/features/virkeskop/services/skogsvard-foryngring.service";

@Component({
    selector: "rask-skogsvard-foryngring-tradslag",
    templateUrl: "./skogsvard-foryngring-tradslag.component.html",
    styleUrls: ["./skogsvard-foryngring-tradslag.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        SelectorComponent,
        FormsModule,
        InputNumberComponent,
        IconButtonComponent
    ]
})
export class SkogsvardForyngringTradslagComponent implements OnChanges {
    @Input() allatradslag: TradslagDTO[];
    @Output() deleted = new EventEmitter<AtgardSkogsvardTradslag>();
    @Input() index: number;
    @Input() kontraktReadonly = false;
    @Input() skogsvardTradslag: AtgardSkogsvardTradslag;
    @Input() skogsvardTradslagLista: AtgardSkogsvardTradslag[];
    @Input() skogsvardsAtgard: Atgard;

    protected valttradslag: TradslagDTO;

    private readonly skogsvardForyngringService = inject(SkogsvardForyngringService);

    private throttle: any;

    ngOnChanges(changes: SimpleChanges): void {
        if (this.allatradslag && this.skogsvardTradslag) {
            this.valttradslag = this.allatradslag.find(t => t.id === this.skogsvardTradslag.tradslagId);
        }
    }

    protected antalPlantorChanged($event) {
        this.skogsvardTradslag.antalPlantor = _.round(this.skogsvardTradslag.antalPlantor, 0);
        this.somethingChanged();
    }

    protected arealandelChanged($event) {
        this.somethingChanged();
    }

    protected delete(): void {
        if (this.kontraktReadonly) {
            return;
        }
        this.deleted.emit(this.skogsvardTradslag);
    }

    protected excludedTradslag() {
        const currentId = this.skogsvardTradslag?.tradslagId;
        const others = this.skogsvardTradslagLista?.filter(x => x.tradslagId && x.tradslagId !== currentId).map(ts => ts.tradslagId);
        return this.allatradslag?.filter(ts => others.some(o => o === ts.id));
    }

    protected frogivaChanged($event) {
        this.skogsvardTradslag.frogiva = _.round(this.skogsvardTradslag.frogiva, 2);
        this.somethingChanged();
    }

    protected tradslagChanged($event) {
        if (!_.isNil($event) && $event?.id !== this.skogsvardTradslag?.tradslagId) {
            this.skogsvardTradslag.tradslagId = $event.id;
            this.update();
        }
    }

    protected viewFormatter = (td: TradslagDTO): string => td != null ? td.externkod : "";

    private somethingChanged(): void {
        clearTimeout(this.throttle);
        this.throttle = setTimeout(() => {
            this.update();
        }, 50);
    }

    private update(): void {
        this.skogsvardForyngringService.updateSkogsvardTradslag(this.skogsvardTradslag);
    }
}
